import { Ref, forwardRef } from "react"
import { Form, FormikProps } from "formik"
import { Formik } from "../../../../../shared/components/forms/SchemaFormik"
import * as yup from "yup"
import { CreateOrEditVatCodesFormValues } from "../vatCodesTypes"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { numericFieldSchema } from "../../../../../shared/components/forms/numericFieldValidation"
import { FormVatCodeContent } from "./FormVatCodeContent"

type CreateOrEditVatCodeFormProps = Readonly<{
    initialValues?: CreateOrEditVatCodesFormValues | null
    onSubmit: (formData: CreateOrEditVatCodesFormValues) => void
}>

const defaultInitialValues: CreateOrEditVatCodesFormValues = {
    name: "",
    code: "",
    vatPercentage: {
        amount: null,
        scale: 1,
    },
}

type FormikRef = Ref<FormikProps<CreateOrEditVatCodesFormValues>>

export const CreateUpdateVatCodeForm = forwardRef(
    ({ initialValues, onSubmit }: CreateOrEditVatCodeFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const validationSchema = yup.object({
            code: yup.string().required(l10n.getString("merchant-vat-codes-create-edit-required-code")),
            name: yup.string().required(l10n.getString("merchant-vat-codes-create-edit-required-name")),
            vatPercentage: yup.object({
                amount: numericFieldSchema(
                    "non-negative-decimal",
                    l10n,
                    l10n.getString("vat-code-vat-percentage-field-name"),
                ).required(l10n.getString("merchant-vat-codes-create-edit-required-vat-percentage-amount")),
            }),
        })

        function handleSubmit(values: CreateOrEditVatCodesFormValues) {
            onSubmit(values)
        }

        return (
            <Formik<CreateOrEditVatCodesFormValues>
                enableReinitialize
                initialValues={initialValues ? initialValues : defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <FormVatCodeContent />
                </Form>
            </Formik>
        )
    },
)
